import { render } from "./TheSideBarMenu.vue?vue&type=template&id=1ed06b55&ts=true"
import script from "./TheSideBarMenu.vue?vue&type=script&lang=ts"
export * from "./TheSideBarMenu.vue?vue&type=script&lang=ts"

import "./TheSideBarMenu.vue?vue&type=style&index=0&id=1ed06b55&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__